import gql from 'graphql-tag';

import client from '../graphqlAPI';

const USER_SOCIAL_LOGIN = gql`
  mutation Post($tokenId: String!) {
    userSocialLogin(
      tokenId: $tokenId,
      ){
        isValid
        token
    }
}`;

const userSocialLogin = async ({ tokenId }) => {
  try {
    const result = await client.mutate({
      mutation: USER_SOCIAL_LOGIN,
      variables: {
        tokenId,
      },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { userSocialLogin: validatedFormData } } = result;

    if (validatedFormData) {
      return validatedFormData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: validatedFormData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: userSocialLogin Error: ${error}`);
    return null;
  }
};

export default userSocialLogin;
